// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-header-dYmCPH{justify-content:space-between;padding:16px 24px 12px;display:flex}.ui-header-dYmCPH .title-loHYEg{color:var(--light-usage-text-color-text-0,#1c1d23);font-size:18px;font-style:normal;font-weight:600;line-height:32px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-header": `ui-header-dYmCPH`,
	"uiHeader": `ui-header-dYmCPH`,
	"title": `title-loHYEg`
};
export default ___CSS_LOADER_EXPORT___;
